<template>
  <ImageHeader :imageSource="require('../assets/leeb-images3/pic1.jpg')" :headerTitle="'Profil-Übersicht'">
    <v-card elevation="0" v-if="this.profiles.length > 1">
      <v-card-text>
        <AccountSelector :profiles="profiles" :loaded="profilesLoaded"></AccountSelector>
      </v-card-text>
    </v-card>

    <v-card class="mb-5" elevation="0">
      <v-card-title>Profil</v-card-title>
      <v-card-text>
        <v-row>
          <v-col sm="12" md="6">
            <h4>Kunde</h4>
            <v-skeleton-loader
              v-if="!customerDataLoaded"
              type="list-item"
            ></v-skeleton-loader>
            <v-list dense v-else>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon>mdi-account</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span>{{ customerData.FullName }}</span>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
          <v-col sm="12" md="6">
            <h4>Kundensaldo</h4>
            <v-skeleton-loader
              v-if="!customerBalanceLoaded"
              type="list-item"
            ></v-skeleton-loader>
            <v-list dense v-else>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon class="pt-2">mdi-cash</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span>{{ $n(customerBalance, 'currency', 'de-DE') }}</span>
                </v-list-item-content>
                <v-list-item-action>
                  <v-list-item-action-text>
                    <v-btn small color="primary" @click="$router.push({path: '/payments'}).catch((error) => {})">
                      Zahlungen <v-icon right dark>mdi-open-in-new</v-icon>
                    </v-btn>
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-card class="mb-5" elevation="0">
      <v-card-title>{{ $t("vaccount.orders") }}</v-card-title>
      <v-card-text>
        <v-data-table
          :headers="orderDataHeader"
          :items="orderData"
          :items-per-page="5"
          :loading="!orderDataLoaded"
          :hide-default-footer="true"
          :hide-default-header="false"
        >
          <template v-slot:[`item.MasterOrderNumber`]="{ item }">
            <b>{{ item.MasterOrderNumber }}</b>
          </template>
          <template v-slot:[`item.Created`]="{ item }">
            <span>{{ $d(Date.parse(item.Created), 'short') }}</span>
          </template>
          <template v-slot:[`item.ExpectedDelivery`]="{ item }">
            <span>{{ item.PrintableExpectedDelivery || $d(Date.parse(item.ExpectedDeliveryDate), 'zCustomMonthYear') }}</span>
          </template>
          <template v-slot:[`item.State`]="{ item }">
            <v-skeleton-loader type="chip" v-if="orderDataStates.findIndex(state => state == item.MasterOrderId) == -1"></v-skeleton-loader>
            <v-chip small color="orange" v-else-if="item.State === 'Processing'">
              <v-icon small left>mdi-cog</v-icon>
              In Bearbeitung
            </v-chip>
            <v-chip small color="green" v-else-if="item.State === 'Finished'">
              <v-icon small left>mdi-check-circle</v-icon>
              Erledigt
            </v-chip>
            <v-chip small color="gray" v-else>
              <v-icon small left>mdi-help-circle</v-icon>
              Unbekannt
            </v-chip>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div :class="['d-flex justify-end align-center']">
              <v-btn color="primary" small @click="$router.push({path: '/overview', query: { id: item.MasterOrderId }}).catch((error) => {})">
                Details
                <v-icon right dark>mdi-open-in-new</v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card :elevation="0">
      <v-card-title>
        {{$t('vaccount.qualityNotifications.title')}}
        <v-spacer></v-spacer>
        <v-btn :color="'primary'" :class="['mr-4']" :loading="!this.masterOrdersLoaded" small @click="qualityNotificationCrationDialogShown = !qualityNotificationCrationDialogShown">{{$t('vaccount.qualityNotifications.create')}}<v-icon right dark>mdi-plus</v-icon></v-btn>
      </v-card-title>
      <v-card-text>
        <v-skeleton-loader
          v-if="!qualityNotificationsLoaded"
          type="list-item@1"
        ></v-skeleton-loader>
        <quality-notifications-overview v-else-if="qualityNotifications.length >= 1" :qualityNotifications="qualityNotifications"></quality-notifications-overview>
        <i v-else>{{$t('vaccount.qualityNotifications.noPositions')}}</i>
      </v-card-text>
    </v-card>
    <v-dialog v-model="qualityNotificationCrationDialogShown" max-width="1000px">
        <quality-notifications-creation-dialog :selectableWorkOrders="this.selectableWorkordersForQualityNotificationCreation" @onQualityNotificationCreation="handleQualityNotificationCreation($event)"></quality-notifications-creation-dialog>
    </v-dialog>
    <!--<v-card elevation="0">
      <v-card-title>Hinweise</v-card-title>
      <v-card-subtitle>Aktuelle Vorgänge welche Ihre Aufmerksamkeit erfodern</v-card-subtitle>
      <v-card-text>
        <v-alert
          dense
          type="info"
        >
          Sie haben eine Nachricht erhalten!
        </v-alert>
        <v-alert
          dense
          type="warning"
        >
          Beim Auftrag FF999999 ist Ihre Zeichnungsfreigabe erforderlich!
        </v-alert>
      </v-card-text>
    </v-card>-->
  </ImageHeader>
</template>

<script>
import ImageHeader from '../components/ImageHeader.vue'
import AccountSelector from '../components/AccountSelector.vue'
import dataAssembler from '../plugins/dataAssembler';
import QualityNotificationsOverview from '../components/QualityNotificationsOverview.vue';
import QualityNotificationsCreationDialog from '../components/QualityNotificationsCreationDialog.vue';

export default {
  name: "Account",
  components: {
    ImageHeader,
    AccountSelector,
    QualityNotificationsOverview,
    QualityNotificationsCreationDialog
  },
  data: () => ({
    profilesLoaded: false,
    profiles: [],

    customerBalanceLoaded: false,
    customerBalance: 0,

    customerDataLoaded: false,
    customerData: {},

    orderDataLoaded: false,
    orderData: [],

    orderDataStates: [],

    qualityNotifications: [],
    qualityNotificationsLoaded: false,

    masterOrdersLoaded: false,
    masterOrders: [],

    qualityNotificationCrationDialogShown: false
  }),
  computed: {
    orderDataHeader: function () {
      return [{
        text: this.$t("vaccount.orderNumber"),
        value: "MasterOrderNumber",
        sortable: false,
        align: "start",
      },{
        text: this.$t("vaccount.orderCreatedAt"),
        value: "Created"
      },{
        text: "Kunde",
        value: "Customer",
        sortable: false
      },{
        text: "Voraussichtliche Lieferung",
        value: "ExpectedDelivery",
        sortable: false
      },{
        text: "Status",
        value: "State",
        sortable: false
      },{
        text: "",
        value: "actions",
        sortable: false
      }];
    },
    selectableWorkordersForQualityNotificationCreation: {
      get: function() {
        let result = [];
        if (this.masterOrders.length === 0) {
          return result;
        }
        this.masterOrders.forEach(masterOrder => {
          let nonComplaintWorkdOrders = masterOrder.WorkOrders.filter(workOrder => workOrder.IsComplaintOrder === false);
          nonComplaintWorkdOrders.forEach(workOrder => {
            result.push({ text: `${workOrder.DisplayName} - ${workOrder.MainItemName}`, value: workOrder.Id });
          });
        });
        return result;
      }
    },
  },
  mounted() {
  },
  methods: {
    /**
     * Intial routine acquires token and select customer number.
     */
    doInit() {
      this.$msal.getSilentToken(this.$msal.getAllAccounts()[0], [
        "offline_access",
        "openid",
        "https://leebcustomer.onmicrosoft.com/customerportal.api/Orders.Read",
      ]).then((response) => {
        this.$store.commit('token', response.accessToken);
        this.$http(dataAssembler.constructInitAxiosQuery(this.$store.getters.token())).then(() => {
          if(this.$store.getters.customerNumber() == '') {
            this.$http(
              dataAssembler.constructProfilesAxiosQuery(this.$store.getters.token())
            ).then((response) => {
              this.$store.commit('customerNumber', response.data[0].CustomerNumber);
            }).catch(() => {});
          } else {
            this.triggerLoad();
          }
        });
      }).catch(() => {
        this.$router.push({ path: "/login" });
      });
    },
    loadProfiles() {
      this.profilesLoaded = false;
      this.profiles = [];
      this.$http(
        dataAssembler.constructProfilesAxiosQuery(this.$store.getters.getToken())
      ).then((response) => {
        this.profiles = response.data;
        this.profilesLoaded = true;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Beim Laden der Profile ist ein Fehler aufgetreten!', 'red darken-1');
      });
    },
    loadCustomerData() {
      this.customerDataLoaded = false;
      this.customerData = [];
      this.$http(
        dataAssembler.constructProfileAxiosQuery(this.$store.getters.token(), this.$store.getters.customerNumber())
      ).then((response) => {
        this.customerData = response.data;
        this.customerDataLoaded = true;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Beim Laden der Kundendaten ist ein Fehler aufgetreten!', 'red darken-1');
      });
    },
    loadOrderData() {
      this.orderDataLoaded = false;
      this.orderData = [];
      this.$http({
        method: "get",
        url: "/api/v1/MasterOrders?customerNumber=" + this.$store.getters.customerNumber(),
        headers: { Authorization: "Bearer " + this.$store.getters.token() },
      }).then((response) => {
        this.orderData = response.data;
        this.orderDataLoaded = true;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Beim Laden der reduzierten Auftragsdaten ist ein Fehler aufgetreten!', 'red darken-1');
      });
    },
    loadCustomerBalance() {
      this.customerBalanceLoaded = false;
      this.customerBalance = 0;
      this.$http(
        dataAssembler.constructProfileBalanceAxiosQuery(this.$store.getters.token(), this.$store.getters.customerNumber())
      ).then((response) => {
        this.customerBalance = response.data;
        this.customerBalanceLoaded = true;
      }).catch((error) => {
        console.error(error);
        this.$snackbar('Beim Laden des Kontostandes ist ein Fehler aufgetreten!', 'red darken-1');
      });
    },
    loadOrderStates() {
      this.orderDataStates = [];
      for (let masterOrder of this.orderData) {
        this.$http({
          method: 'get',
          url: `/api/v1/MasterOrders/${masterOrder.MasterOrderId}?customerNumber=${this.$store.getters.customerNumber()}`,
          headers: { Authorization: `Bearer ${this.$store.getters.token()}` }
        }).then((response) => {
          let stateResult = "";
          for (let workOrder of response.data.WorkOrders) {
            let timeLineConfig = dataAssembler.calculateTimeLineConfig(workOrder.WorkOrderFieldOrders, workOrder.Events, workOrder.WorkOrderFlag, workOrder.IsInstallationOrder);
            // TODO: 
            let lastNonGreen = timeLineConfig.colors.findIndex((value) => value !== "green");
            if (lastNonGreen === -1 || (lastNonGreen === 5 && !workOrder.IsInstallationOrder)) {
              // All green
              stateResult = "Finished";
            } else {
              stateResult = "Processing";
              break;
            }
          }
          masterOrder.State = stateResult;
          this.orderDataStates.push(masterOrder.MasterOrderId);
        }).catch((error) => {
          console.error(error);
          this.$snackbar('Beim Laden der reduzierten Auftrags-Status ist ein Fehler aufgetreten!', 'red darken-1');
        });
      }
    },
    loadQualityNotifications() {
      this.qualityNotificationsLoaded = false;
      this.qualityNotifications = [];
      dataAssembler.loadQualityNotifications(this.$store.getters.token(), this.$store.getters.customerNumber(), { loadReportedByUser: false, loadReportedByCustomer: false }).then((qualityNotifications) => {
        this.qualityNotifications = qualityNotifications;
        this.qualityNotificationsLoaded = true;
      }).catch((error) => {
        console.error("Error while loading QualityNotification!", error);
        this.$snackbar('Beim Laden der Qualitätsmeldungen ist ein Fehler aufgetreten!', 'red darken-1');
      });
    },
    loadMasterOrders: async function() {
      this.masterOrdersLoaded = false;
      this.masterOrders = [];
      for (let orderDataEntry of this.orderData) {
        await this.$http(
          dataAssembler.contructMasterOrderAxiosQuery(orderDataEntry.MasterOrderId, this.$store.getters.customerNumber(), this.$store.getters.token())
        ).then((response) => {
          this.masterOrders.push(response.data);
        }).catch((error) => {
          console.error(error);
          this.$snackbar('Beim Laden der Hauptaufträge ist ein Fehler aufgetreten!', 'red darken-1');
        });
      }
      this.masterOrdersLoaded = true;
    },
    handleQualityNotificationCreation: function(event) {
      this.qualityNotificationCrationDialogShown = !this.qualityNotificationCrationDialogShown;

      if (event.success === true) {
        this.$snackbar(event.message, 'green darken-1');
        this.loadQualityNotifications();
      } else {
        console.error(event.object);
        this.$snackbar(event.message, 'red darken-1');
      }
    },
    triggerLoad() {
      this.loadProfiles();
      this.loadCustomerData();
      this.loadCustomerBalance();
      this.loadOrderData();
      this.loadQualityNotifications();
    }
  },
  updated() {
  },
  created() {
    this.doInit();
  },
  watch: {
    '$store.state.customerNumber': function(val) {
      if (val != null && val != undefined && val != '') {
        this.triggerLoad();
      }
    },
    orderDataLoaded(newValue) {
      if (newValue === true) {
        this.loadOrderStates();
        this.loadMasterOrders();
      }
    },
  },
};
</script>
